import React from 'react';
import { TableBody, TableRow } from '../../../../../../../../../CommonComponents/OPL/Table/Table';
import { Box } from '../../../../../../../../../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../../../../../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';

interface TransfersErrorProps {
  onRetry(): void;
}

export const TransfersError: React.FC<TransfersErrorProps> = ({ onRetry }) => {
  return (
    <TableBody>
      <TableRow>
        <Box p="56" width="100%">
          <ErrorState onAction={onRetry} />
        </Box>
      </TableRow>
    </TableBody>
  );
};
